import * as React from 'react'
import {Box,Typography,Paper,Grid,TextField,Container,InputBase,Button,CircularProgress,InputAdornment,IconButton} from '@mui/material'
import {styled,useTheme} from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import { login} from "../Redux/authSlice";
import {useNavigate} from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery';
import { Snackbar } from '@mui/material';
import Lottie from "lottie-react";
import { BookOnline } from '@mui/icons-material';
import axios from 'axios';

const StartBox = styled(Box, {
})(({ theme}) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
minHeight:300,
display:"flex",
flexWrap:"wrap",
justifyContent:"space-evenly",
paddingTop:10,
borderRadius:10,
maxWidth:"90%",
flexDirection:"row"
})
);

const Verify = ()=>{

const theme = useTheme()
const [code,setCode] = React.useState('');
const [password,setPassword] = React.useState('')
const [loading,setLoading] = React.useState(false)
const [sending,setSending] = React.useState(false)
const [loaded,setLoaded] = React.useState(true)
const [visible, setVisible] = React.useState(false);
const [open, setOpen] = React.useState(false);
const [type, setType] = React.useState("error");
const [message, setMessage] = React.useState("");
const [isAllowed, setIsAllowed] = React.useState(true);
const [time, setTime] = React.useState(30);
const navigate = useNavigate()
const size_xs = useMediaQuery(theme.breakpoints.up('xs'));
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const user = useSelector(state => state?.auth.user);
const dispatch = useDispatch()
let tim = 30

async function handleRequest (){
    try{
        if (isAllowed) {
            
            setSending(true)
            const send_data ={email:user?.email}

            const sendRequest = await axios.post(`${process.env.REACT_APP_SERVER_URL}request-code`,send_data).catch(err=>{
                setMessage("Error, please verify your network and try later")
                setOpen(true)
                setSending(false)
                console.log(err)
            })

            if (sendRequest?.status == 200 && sendRequest?.data?.success) {
                setMessage(sendRequest?.data?.message)
                setOpen(true)
                setSending(false)
                startCoolDown()
            }else{
                setMessage(sendRequest?.data?.message)
                setOpen(true)
                setSending(false)
            }
    } else {
        setMessage("wait until the countdown")
        setOpen(true)
    }
    }catch(err){
    console.log(err)
    }
}

async function handleVerify (){
try{
if (code !== '') {

    setLoading(true)

    const send_data ={
        email:user?.email,
        code:code
    }
    const verify = await axios.post(`${process.env.REACT_APP_SERVER_URL}verify`,send_data).catch(err=>{
        setMessage("Error, please verify your network and try later")
        setOpen(true)
        setLoading(false)
        console.log(err)
    })

    if (verify?.status == 200 && verify?.data?.success) {
        
        const userData = {
            ...user,
            isVerified:true,
            auth:true
        }
        localStorage.clear()
        localStorage.removeItem("iTestUser")
        localStorage.setItem("iTestUser",JSON.stringify(userData))
        dispatch(login(userData))

        navigate("/dashboard")
        setMessage(verify?.data?.message)
        setOpen(true)
        setLoading(false)

    }else{
        setMessage(verify?.data?.message)
        setOpen(true)
        setLoading(false)
    }

} else {
    setMessage("please write down the code that we sent")
    setType("error")
    setOpen(true)
}
}catch(err){
    console.log(err)
}
}


const handleSnackbarClose = ()=>{
setOpen(false)
}

const startCoolDown = () => {
    setIsAllowed(false);
    setTime(30);
    const countdown = setInterval(() => {
      setTime((prev) => {
        if (prev === 1) {
          clearInterval(countdown);
          setIsAllowed(true);
          return 30;
        }
        return prev - 1;
      });
    }, 1000);
  };

React.useEffect(() => {
    if (!isAllowed) startCoolDown();
  }, [isAllowed]);


return(
<Grid container>
    <Grid item xs={12} sm={12} md={12} style={{height:70}}>
    </Grid>
    <Grid item xs={12} sm={12} md={12} sx={{justifyContent:"center",alignItems:"center",marginLeft:{xs:4,md:15}}}>
        <Snackbar anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }} message={message} 
            onClose={handleSnackbarClose} 
            open={open} 
            autoHideDuration={2000}

        />
        <StartBox sx={{background:{xs:"#000000",md:"#100101"}}}>
        <Box justifyContent="center" alignItems="center">
            <form style={{backgroundColor:"black",padding:10,marginTop:10,marginBottom:10,boxShadow:"0px 0px 10px 2px rgba(0,0,0,0.2)",borderRadius:15}}>
                <Box m={1} display="flex" flexDirection="row">
                    <img width={50} height={50} src={require('../assets/itest.png')}/>
                    <Typography  mb={3} mt={1} ml={2} fontSize={30} color="gold" fontWeight={900} sx={{fontFamily:"zolla"}}>
                        iTest
                    </Typography>
                </Box>
                    <Typography  mb={1} mt={2} ml={2} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
                        Verify your account
                    </Typography>
                    <Typography mb={2}  ml={2} sx={{fontSize:11,fontWeight:400,color:"gray"}}>
                        We have sent you an email code to your address - {user?.email}
                    </Typography>
                    <Box m={2}>
                        <Typography fontSize={14} mb={2} variant="h6" color="gold" sx={{fontFamily:"geruduk"}}>
                           Code *
                        </Typography> 
                        <TextField
                            label="code"
                            onChange={(e)=>{setCode(e.target.value)}}
                            placeholder='code...'
                            type="text"
                            required
                            sx={{minHight:30,maxWidth:280}}
                            value={code}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
                                        <BookOnline /> 
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>
                    <Typography mb={2}  ml={2} sx={{fontSize:11,fontWeight:400,color:"gray"}}>
                        Request a new code in {time}
                    </Typography>
                    <Box mt={1} ml={2} sx={{flexDirection:{xs:"column",md:"row"}}}>
                        <Button  onClick={(e)=>{
                                e?.preventDefault()
                                handleVerify()
                            }} disabled={loading} sx={{backgroundColor:"gold",color:"black",marginRight:{xs:5,md:5},fontSize:{xs:10,md:12},height:35,width:100,fontFamily:"dinofans"}} variant="contained">
                            {
                                loading ? <CircularProgress size={20} style={{color:"black"}}/> : "VERIFY"
                            }
                        </Button>
                        <Button  onClick={(e)=>{
                                e?.preventDefault()
                                handleRequest()
                            }} disabled={sending || !isAllowed} sx={{backgroundColor:"gold",color:"black",marginRight:{xs:5,md:5},fontSize:{xs:10,md:12},height:35,width:100,fontFamily:"dinofans"}} variant="contained">
                            {
                                sending ? <CircularProgress size={20} style={{color:"black"}}/> : "Request"
                            }
                        </Button>
                    </Box>
                </form>
            </Box>
            <Box sx={{width:{xs:"80%",md:"45%"}}} display="block" justifyContent="flex-start" alignItems="flex-start" pt={3}>
                <Box sx={{display:{xs:"none",md:"block"},textAlign:"center",width:"100%"}}>
                    <Typography fontWeight={500} mb={2} sx={{marginLeft:{xs:0,md:4,fontFamily:"dinofans",fontSize:25}}} color="#ffffff" textAlign="center">
                        TALENT ASSESSMENT HIRING 
                    </Typography>
                    <Lottie style={{width:200,height:250,marginLeft:120}} animationData={require("../assets/anim2.json")}  />
                </Box>
                <Box flexDirection="row" display="flex" ml={2} sx={{justifyContent:"space-evenly",alignContent:"center",width:"98%"}}>
                    <Box sx={{width:"80%",padding:1}}>
                        <Typography  sx={{fontWeight:500,color:"#ffffff",fontFamily:"dinofans"}}>
                                USE AI FOR AN ASSESSMENT HIRING
                        </Typography>
                        <Typography  sx={{fontWeight:500,color:"#ffffff",fontSize:3,marginTop:2}}>
                            we make individuals or organizations to process the assessment to hire an employer in any field using Google's Generative Text AI  Gemini  to create assessment
                        </Typography> 
                    </Box>
                </Box>
            </Box>
        </StartBox>
    </Grid>
    <Grid item xs={12} sm={12} md={12} style={{height:40}}>
    </Grid>
</Grid>
)

}

export default Verify